import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/personal/page';

export const Route = createFileRoute('/_app/settings/personal/')({
  component: Page,
});
